import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { tap } from "rxjs/operators";
import { PublicHttpClientService } from "./http-client.service";

@Injectable()
export class PublicMailerService {
  constructor(private publicHttp: PublicHttpClientService) {}

  public agencyContact(data): Observable<any> {
    return this.publicHttp
      .post("/api/public/mailer/agency_contact", data)
      .pipe(tap((_) => console.log("PublicMailerService.agencyContact: Ok.")));
  }

  public independentContact(data): Observable<any> {
    return this.publicHttp
      .post("/api/public/mailer/independent_contact", data)
      .pipe(tap((_) => console.log("PublicMailerService.independentContact: Ok.")));
  }

  public clientSupport(data): Observable<any> {
    return this.publicHttp
      .post("/api/public/mailer/client_support", data)
      .pipe(tap((_) => console.log("PublicMailerService.clientSupport: Ok.")));
  }

  public contactEmail(data): Observable<any> {
    return this.publicHttp
      .post("/api/public/mailer/contact_email", data)
      .pipe(tap((_) => console.log("PublicMailerService.contactEmail: Ok.")));
  }
}
